import React, {useState} from "react";
import Button from "components/ui/Button";
import InfoRow from "components/ui/InfoRow";
import Icon from "components/AppIcon";
import { bookingPayment } from "services/bookingService";
import { toast } from "react-toastify";

const PaymentModal = ({
  onSuccessfullPayment,
  onCancellation,
  open=false,
  booking
}) => {

    const [isLoading, setIsLoading] = useState(false);

    // Format amount due as currency (ZAR)
    const formattedAmount = new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(booking?.totalAmountDue ?? 0));

    if (!open) return null;

    const acknowledgePayment= async ()=>{
        setIsLoading(true);
        const results = await bookingPayment(booking.businessId, booking.id, {amount: booking.totalAmountDue});
        console.log(results);
        if(results.success){
            toast.success('Payment acknowledged successfully');
            onSuccessfullPayment(booking.id);
            setIsLoading(false);
        }
        else{
            toast.error(results.message || 'Failed to acknowledge payment. Please try again.');
            setIsLoading(false);
        }
    }

    return (
        <div className="fixed inset-0 z-1002 overflow-y-auto flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50  transition-opacity"
                onClick={onCancellation}
            />
            {/* Modal */}
            <div className="relative bg-white dark:bg-gray-900 rounded-xl shadow-xl p-6 w-full max-w-md mx-4 z-10 m-2">
                <h2 className="text-lg text-center font-semibold mb-2 text-gray-900 dark:text-white">
                Payment
                </h2>
                <hr />
                
                {/* Vehicle Details */}
                <div className="space-y-4 my-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* <InfoRow icon="User" label="Customer" value={booking?.name+' '+booking?.surname} />
                    <InfoRow icon="Phone" label="Customer" value={booking?.contactNumber} /> */}
                    <InfoRow icon="Car" label="Vehicle" value={booking.bookedItemDetails.colour+' '+booking.bookedItemDetails.name+' '+booking.bookedItemDetails.model} />
                    <InfoRow icon="ScanLine" label="Registration Number" value={booking?.bookedItemDetails.registrationNo} />
                    </div>
                </div>

                {/* OTP Details */}
                <div className="flex flex-col items-center mx-6 mt-2 border border-border rounded px-4 py-3 bg-gray-50 dark:bg-gray-800 shadow">
                    <h3 id="AmountDue" className="text-green-900 text-xl font-semibold mb-1">{formattedAmount} Due</h3>
                    {/* <label className="text-center text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Enter Payment Amount
                    </label>
                    <input
                        disabled
                        value={booking.totalAmountDue}
                        type="number"
                        className="text-center w-3/4 border border-border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="Enter Amount"
                    /> */}
                </div>
                {/* <div className="flex flex-col items-center mx-6 mt-4">
                        <div className="flex flex-row justify-center items-center space-x-2 mt-1 text-primary font-medium cursor-pointer">
                            <Icon name='RefreshCcw' size={18} className=" mt-0.5 flex-shrink-0" />
                            <span>Reset</span>
                        </div>
                </div> */}

                <div className="flex justify-center gap-2 mt-6">
                    <Button
                        onClick={onCancellation}
                        className="w-40 px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 transition"
                    >
                        Cancel Payment
                    </Button>
                    <Button
                        loading={isLoading}
                        onClick={()=>acknowledgePayment()}
                        className="w-40 px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
                    >
                        Confirm Payment
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;